import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getSession, signOut } from "@/features/auth/auth-client";

export const Route = createFileRoute("/(auth)")({
  component: RouteComponent,
  beforeLoad: async () => {
    const { data } = await getSession();
    const roles = data?.user.role?.split(",").map((role) => role.trim()) ?? [];
    if (data?.session && roles.some((role) => role === "admin" || role === "editor")) {
      throw redirect({
        to: "/",
        replace: true,
      });
    }

    if (data?.session) await signOut();
  },
});

function RouteComponent() {
  return (
    <div className="container grid h-svh max-w-none items-center justify-center">
      <div className="mx-auto flex w-full flex-col justify-center space-y-2 py-8 sm:w-120 sm:p-8">
        <div className="mb-4 flex items-center justify-center">
          <h1 className="font-medium text-xl">Homeland</h1>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
